import {loadMapMenuItems} from '@/helpers/map_menu/map_menu_items';

const state = {
  themeMapMenuItems: undefined,
};

const mutations = {
  setThemeMapMenuItems(state, data) {
    state.themeMapMenuItems = data;
  },
};

const actions = {

  async loadThemeMapMenuItems({commit}, payload) {
    const {from} = payload;
    try {
      const response = await loadMapMenuItems();
      commit('setThemeMapMenuItems', response.data[from]);
    } catch (error) {
      commit('setThemeMapMenuItems', undefined);
    }
  },
};

const getters = {
  themeMapMenuItems: (state) => state.themeMapMenuItems,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
